import doesVendorHaveLowestDeliveryDate from "@/app/ec/product/[basePath]/vendor-options/doesVendorHaveLowestDeliveryDate";

/** Finds the lowest vendor delivery day amongst the provided vendor options */
export default function findLowestVendorDeliveryDay(vendorOptions: VendorOptionState[]): number {
  let lowestDeliveryDays = 0;

  vendorOptions.forEach((vendor) => {
    const hasLowestDeliveryDays = doesVendorHaveLowestDeliveryDate(vendor.vendorId, vendorOptions);

    if (hasLowestDeliveryDays && vendor.arrivalBusinessDays) {
      lowestDeliveryDays = vendor.arrivalBusinessDays;
    }
  });

  return lowestDeliveryDays;
}
